module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footers",
    class: {
      'newV-footers': (_vm.vipState === 0 || _vm.vipState === 'loginNo')
    }
  }, [_c('div', {
    staticClass: "footer-bg"
  }), _vm._v(" "), _c('p', {
    staticClass: "footer-con"
  }, [_vm._v("开启应聘快车道，与众不同立即开始")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-008ff8a3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/footer/Footer.vue
// module id = +ahz
// module chunks = 1